import script from "./Screen.vue?vue&type=script&setup=true&lang=js"
export * from "./Screen.vue?vue&type=script&setup=true&lang=js"

import "./Screen.vue?vue&type=style&index=0&id=7e9a11f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9a11f5"]])

export default __exports__